/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BadRequestErrorResponse,
    BadRequestErrorResponseFromJSON,
    BadRequestErrorResponseToJSON,
    ConflictErrorResponse,
    ConflictErrorResponseFromJSON,
    ConflictErrorResponseToJSON,
    DeleteAllRulesRequest,
    DeleteAllRulesRequestFromJSON,
    DeleteAllRulesRequestToJSON,
    NewResourceResponse,
    NewResourceResponseFromJSON,
    NewResourceResponseToJSON,
    NotFoundErrorResponse,
    NotFoundErrorResponseFromJSON,
    NotFoundErrorResponseToJSON,
    UpgradeRuleRequest,
    UpgradeRuleRequestFromJSON,
    UpgradeRuleRequestToJSON,
    UpgradeRuleResponse,
    UpgradeRuleResponseFromJSON,
    UpgradeRuleResponseToJSON,
    UpgradeRuleValidateInfoResponse,
    UpgradeRuleValidateInfoResponseFromJSON,
    UpgradeRuleValidateInfoResponseToJSON,
    UpgradeRulesResponse,
    UpgradeRulesResponseFromJSON,
    UpgradeRulesResponseToJSON,
} from '../models';

export interface CreateUpgradeRuleRequest {
    upgradeRuleRequest: UpgradeRuleRequest;
}

export interface DeleteUpgradeRuleRequest {
    id: string;
}

export interface DeleteUpgradeRulesRequest {
    deleteAllRulesRequest?: DeleteAllRulesRequest;
}

export interface ReadEmptyUpgradeRulesRequest {
    offset?: number | null;
    limit?: number | null;
}

export interface ReadUnusedUpgradeRulesRequest {
    offset?: number | null;
    limit?: number | null;
}

export interface ReadUpgradeRuleRequest {
    id: string;
}

export interface ReadUpgradeRulesRequest {
    filter?: string | null;
    filterDeviceTypeIds?: Array<string> | null;
    filterSuperGroupId?: string | null;
    offset?: number | null;
    limit?: number | null;
}

export interface ReadValidateInfoForUpdateRuleRequest {
    id: string;
}

export interface UpdateUpgradeRuleRequest {
    id: string;
    upgradeRuleRequest: UpgradeRuleRequest;
}

/**
 * 
 */
export class UpgradeRulesApi extends runtime.BaseAPI {

    /**
     * Create a upgrade rule.
     */
    async createUpgradeRuleRaw(requestParameters: CreateUpgradeRuleRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<NewResourceResponse>> {
        if (requestParameters.upgradeRuleRequest === null || requestParameters.upgradeRuleRequest === undefined) {
            throw new runtime.RequiredError('upgradeRuleRequest','Required parameter requestParameters.upgradeRuleRequest was null or undefined when calling createUpgradeRule.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/upgradeRules`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpgradeRuleRequestToJSON(requestParameters.upgradeRuleRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NewResourceResponseFromJSON(jsonValue));
    }

    /**
     * Create a upgrade rule.
     */
    async createUpgradeRule(requestParameters: CreateUpgradeRuleRequest, initOverrides?: RequestInit): Promise<NewResourceResponse> {
        const response = await this.createUpgradeRuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete upgrade rule by ID.
     */
    async deleteUpgradeRuleRaw(requestParameters: DeleteUpgradeRuleRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteUpgradeRule.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/upgradeRules/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete upgrade rule by ID.
     */
    async deleteUpgradeRule(requestParameters: DeleteUpgradeRuleRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteUpgradeRuleRaw(requestParameters, initOverrides);
    }

    /**
     * Delete upgrade rules by IDs.
     */
    async deleteUpgradeRulesRaw(requestParameters: DeleteUpgradeRulesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/upgradeRules`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteAllRulesRequestToJSON(requestParameters.deleteAllRulesRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete upgrade rules by IDs.
     */
    async deleteUpgradeRules(requestParameters: DeleteUpgradeRulesRequest = {}, initOverrides?: RequestInit): Promise<void> {
        await this.deleteUpgradeRulesRaw(requestParameters, initOverrides);
    }

    /**
     * Read upgrade rules which have stb group without devices.
     */
    async readEmptyUpgradeRulesRaw(requestParameters: ReadEmptyUpgradeRulesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<UpgradeRulesResponse>> {
        const queryParameters: any = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/upgradeRules/empty`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpgradeRulesResponseFromJSON(jsonValue));
    }

    /**
     * Read upgrade rules which have stb group without devices.
     */
    async readEmptyUpgradeRules(requestParameters: ReadEmptyUpgradeRulesRequest = {}, initOverrides?: RequestInit): Promise<UpgradeRulesResponse> {
        const response = await this.readEmptyUpgradeRulesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read unused upgrade rules.
     */
    async readUnusedUpgradeRulesRaw(requestParameters: ReadUnusedUpgradeRulesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<UpgradeRulesResponse>> {
        const queryParameters: any = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/upgradeRules/unused`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpgradeRulesResponseFromJSON(jsonValue));
    }

    /**
     * Read unused upgrade rules.
     */
    async readUnusedUpgradeRules(requestParameters: ReadUnusedUpgradeRulesRequest = {}, initOverrides?: RequestInit): Promise<UpgradeRulesResponse> {
        const response = await this.readUnusedUpgradeRulesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read upgrade rule by ID.
     */
    async readUpgradeRuleRaw(requestParameters: ReadUpgradeRuleRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<UpgradeRuleResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling readUpgradeRule.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/upgradeRules/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpgradeRuleResponseFromJSON(jsonValue));
    }

    /**
     * Read upgrade rule by ID.
     */
    async readUpgradeRule(requestParameters: ReadUpgradeRuleRequest, initOverrides?: RequestInit): Promise<UpgradeRuleResponse> {
        const response = await this.readUpgradeRuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read upgrade rules.
     */
    async readUpgradeRulesRaw(requestParameters: ReadUpgradeRulesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<UpgradeRulesResponse>> {
        const queryParameters: any = {};

        if (requestParameters.filter !== undefined) {
            queryParameters['filter'] = requestParameters.filter;
        }

        if (requestParameters.filterDeviceTypeIds) {
            queryParameters['filterDeviceTypeIds'] = requestParameters.filterDeviceTypeIds;
        }

        if (requestParameters.filterSuperGroupId !== undefined) {
            queryParameters['filterSuperGroupId'] = requestParameters.filterSuperGroupId;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/upgradeRules`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpgradeRulesResponseFromJSON(jsonValue));
    }

    /**
     * Read upgrade rules.
     */
    async readUpgradeRules(requestParameters: ReadUpgradeRulesRequest = {}, initOverrides?: RequestInit): Promise<UpgradeRulesResponse> {
        const response = await this.readUpgradeRulesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read validate info before update rule.
     */
    async readValidateInfoForUpdateRuleRaw(requestParameters: ReadValidateInfoForUpdateRuleRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<UpgradeRuleValidateInfoResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling readValidateInfoForUpdateRule.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/upgradeRules/{id}/validateUpdate`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpgradeRuleValidateInfoResponseFromJSON(jsonValue));
    }

    /**
     * Read validate info before update rule.
     */
    async readValidateInfoForUpdateRule(requestParameters: ReadValidateInfoForUpdateRuleRequest, initOverrides?: RequestInit): Promise<UpgradeRuleValidateInfoResponse> {
        const response = await this.readValidateInfoForUpdateRuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update upgrade rule by ID.
     */
    async updateUpgradeRuleRaw(requestParameters: UpdateUpgradeRuleRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateUpgradeRule.');
        }

        if (requestParameters.upgradeRuleRequest === null || requestParameters.upgradeRuleRequest === undefined) {
            throw new runtime.RequiredError('upgradeRuleRequest','Required parameter requestParameters.upgradeRuleRequest was null or undefined when calling updateUpgradeRule.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/upgradeRules/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpgradeRuleRequestToJSON(requestParameters.upgradeRuleRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update upgrade rule by ID.
     */
    async updateUpgradeRule(requestParameters: UpdateUpgradeRuleRequest, initOverrides?: RequestInit): Promise<void> {
        await this.updateUpgradeRuleRaw(requestParameters, initOverrides);
    }

}
